import endpoints, { baseApiUrl } from 'libs/src/config/endpoints';
import { HTTPMethod, HTTPStatusCode } from 'libs/src/enums';
import { fetchAsync } from 'libs/src/services/NetworkHelper';

export const addBasicDetails = async (
  accountId: any,
  basicDetailsPayload: any,
): Promise<any> => {
  try {
    const request = {
      method: HTTPMethod.POST,
      data: basicDetailsPayload,
      url: baseApiUrl + endpoints.customers + accountId + endpoints.getHolders,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return response.error;
  } catch (error) {
    return [];
  }
};
export const updateBasicDetails = async (
  accountId: any,
  holderId: any,
  basicDetailsPayload: any,
): Promise<any> => {
  try {
    const request = {
      method: HTTPMethod.PUT,
      data: basicDetailsPayload,
      url:
        baseApiUrl +
        endpoints.customers +
        accountId +
        endpoints.getHolders +
        '/' +
        holderId +
        endpoints.updateBasicDetails,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return response.error;
  } catch (error) {
    return [];
  }
};
